"use client";

import { Header } from "@/components/booking/header";
import { Footer } from "@/components/booking/footer";
import { AuthModal } from "@/components/booking/auth-modal";
import { DocumentationView } from "@/components/booking/docs/documentation-view";

export default function DocumentationPage() {
  return (
    <div className="flex min-h-screen flex-col">
      <Header />
      <main className="flex-1">
        <DocumentationView />
      </main>
      <Footer />
      <AuthModal />
    </div>
  );
}
